import React, { useEffect, useState } from "react"
import UHCTemplateContract, { UHCTemplateContractProps } from "@/components/Dumb/Templates/Contract/Contract"
import UHCHeader from "../../Molecules/Image/Header/HeaderPage"
import UHCFooter from "../../Molecules/Image/Footer/FooterPage"
import { ImagesResponse, ServerCatalogResponse } from "./utils/types/Contract.grapqhl.types"
import { getInitialCollapse, getInitialHardware, getInitialImage } from "./services/Contract.service"
import { CurrentProfile, QuerysResponse } from "./utils/types/Contract.types"
import { usePrevious } from "@/hooks"
import { Image } from "../../Cloud.model"
import { callBackOnclickLineImageLocked, convertDatasToPipes, setSlideMinOrIncluded, updateCurrentImage } from "./services/UiCloudMaterial.service"
import { getElementSidebar, getElementsBoxes } from "./services/ContractElements.service"
import { Content } from "../ContractCloudStyled"

export type ContractCloudProps = {
    hardwareQueryResponse: ServerCatalogResponse | undefined,
    imagesQueryResponse: ImagesResponse | undefined,    
    statusPage: UHCTemplateContractProps['status'],
    priceGroup: string | null
}

const ContractCloud = ({ hardwareQueryResponse, imagesQueryResponse, statusPage, priceGroup }: ContractCloudProps) => {

    let boxesElement, sidebarElement
    const [imageSelected, setImageSelected] = useState<Image>()

    const imageSelectedIndex = useState(getInitialImage(window.location))
    const isCollapse = useState(getInitialCollapse(window.location))

    const hardwareInitialState = getInitialHardware(window.location)

    const hardwareSelectedIndex: CurrentProfile = {
        compute: useState(parseInt(hardwareInitialState.compute)),
        bandwidth: useState(parseInt(hardwareInitialState.bandwidth)),
        disk: useState(parseInt(hardwareInitialState.disk))
    }

    useEffect(() => {
        const hasImageSelected = !(!imageSelected)
        if (!imagesQueryResponse?.images || hasImageSelected) return

        setImageSelected(imagesQueryResponse.images[getInitialImage(window.location)])
    }, [imagesQueryResponse])

    useEffect(() => {
        if (hardwareQueryResponse) {
            setSlideMinOrIncluded(hardwareQueryResponse.serverCatalog, 
                hardwareSelectedIndex, 
                previousComputeIndex, 
                imagesQueryResponse?.images[imageSelectedIndex[0]], )
        }
    }, [hardwareSelectedIndex.compute[0]])
   

    const previousComputeIndex = usePrevious(hardwareSelectedIndex.compute[0])

    if (imagesQueryResponse && hardwareQueryResponse) {
        const onclickSetImageSelected = (images: Image[], index: number) => {
            updateCurrentImage(images, index, setImageSelected, imageSelectedIndex[1])
        }
                
        const querysResponse: QuerysResponse = {
            images: imagesQueryResponse.images,
            serverCatalog: hardwareQueryResponse.serverCatalog,
            group: priceGroup
        }

        const pipesConverted = convertDatasToPipes(hardwareQueryResponse.serverCatalog,
                                                   imagesQueryResponse.images[imageSelectedIndex[0]],
                                                   hardwareSelectedIndex)

        const onclickLineImageOnLock = callBackOnclickLineImageLocked(
            querysResponse,
            hardwareSelectedIndex,
            setImageSelected,
            imageSelectedIndex[1],
        )
        
    
        boxesElement = getElementsBoxes(
            querysResponse,
            hardwareSelectedIndex,
            isCollapse,
            pipesConverted,
            onclickSetImageSelected,
            onclickLineImageOnLock,
            imageSelectedIndex
        )

        sidebarElement = getElementSidebar(
            querysResponse,
            pipesConverted,
            hardwareSelectedIndex,
            imageSelectedIndex,
            imageSelected
        )
    }

    return (
        <Content>
            <UHCHeader />
            
            <div style={{ marginBottom: 80 }}>
                <UHCTemplateContract status={statusPage} boxes={boxesElement} sidebar={sidebarElement} />
            </div>

            <UHCFooter />
        </Content>
    )
}

export default ContractCloud;